var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171_977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4302 5.90791C24.446 6.12998 24.446 6.3521 24.446 6.57417C24.446 13.3476 19.2906 21.1522 9.86802 21.1522C6.96509 21.1522 4.26841 20.3114 2 18.8521C2.41245 18.8997 2.80898 18.9155 3.2373 18.9155C5.63257 18.9155 7.83755 18.1065 9.59834 16.7265C7.3458 16.6789 5.45811 15.2036 4.80771 13.1731C5.125 13.2207 5.44224 13.2524 5.77539 13.2524C6.2354 13.2524 6.69546 13.189 7.12373 13.078C4.77603 12.602 3.01519 10.5399 3.01519 8.04941V7.98599C3.69727 8.3667 4.49048 8.60464 5.33115 8.63633C3.95107 7.71626 3.04692 6.14585 3.04692 4.36919C3.04692 3.41743 3.30068 2.54497 3.74487 1.78354C6.26709 4.89268 10.0583 6.9231 14.3096 7.14522C14.2303 6.7645 14.1827 6.36797 14.1827 5.97139C14.1827 3.14775 16.4669 0.847656 19.3064 0.847656C20.7816 0.847656 22.1141 1.46631 23.05 2.46567C24.208 2.2436 25.3184 1.81528 26.302 1.22837C25.9212 2.41812 25.1122 3.41748 24.0494 4.05195C25.0805 3.94097 26.0799 3.65537 26.9999 3.25884C26.302 4.27402 25.4295 5.17817 24.4302 5.90791Z",
    fill: "#ECB956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4158 5.88819L24.4049 5.89617L24.4058 5.90965C24.4216 6.13071 24.4216 6.35196 24.4216 6.57417C24.4216 13.3371 19.2743 21.1278 9.86802 21.1278C7.00731 21.1278 4.34735 20.31 2.10118 18.8877C2.47789 18.9266 2.84441 18.9399 3.2373 18.9399C5.63818 18.9399 7.84843 18.129 9.6134 16.7457L9.66721 16.7035L9.59886 16.7021C7.37075 16.655 5.50143 15.2045 4.84309 13.203C5.14822 13.2475 5.45435 13.2769 5.77539 13.2769C6.2376 13.2769 6.69971 13.2131 7.12985 13.1016L7.12858 13.0541C4.79201 12.5804 3.0396 10.528 3.0396 8.04941V8.02738C3.71668 8.39817 4.50042 8.62944 5.33023 8.66072L5.41665 8.66398L5.3447 8.61601C3.97115 7.7003 3.07134 6.13737 3.07134 4.36919C3.07134 3.43462 3.31714 2.57699 3.74827 1.82641C6.27475 4.92526 10.0625 6.94776 14.3083 7.1696L14.3399 7.17125L14.3335 7.14024C14.2545 6.7609 14.2071 6.36604 14.2071 5.97139C14.2071 3.16119 16.4805 0.87207 19.3064 0.87207C20.7747 0.87207 22.1008 1.48777 23.0322 2.48236L23.0414 2.49219L23.0546 2.48965C24.1936 2.27124 25.2865 1.8538 26.2586 1.28244C25.8718 2.43931 25.0763 3.41046 24.0369 4.03099L24.052 4.07623C25.0568 3.96808 26.0312 3.69459 26.9316 3.31451C26.2435 4.29925 25.39 5.17681 24.4158 5.88819Z",
    stroke: "#ECB956",
    strokeWidth: 0.0488281
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171_977",
    x: 0,
    y: 0.847656,
    width: 28.9999,
    height: 26.3044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171_977",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.176a7f6d13e47ffd9066433d4353eecc.svg";
export { ForwardRef as ReactComponent };